<ng-container *ngIf="loadingTour; else tourContent">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</ng-container>
<ng-template #tourContent>
  <div class="tour">
    <div class="placer-info-container" [ngClass]="placerNameBackgroundClass">
      <div class="vertical-center-container">
        <div class="placer">
          <div class="vertical-center">
            <div class="absent-checkbox">
              <mat-checkbox
                [matTooltip]="
                  tour.placerAbsent ? 'Zet op niet afwezig' : 'Zet op afwezig'
                "
                [ariaLabel]=""
                [(ngModel)]="tour.placerAbsent"
                (ngModelChange)="togglePlacerAbsent()"
              ></mat-checkbox>
            </div>
          </div>
          <div class="vertical-center">
            <div class="placer-name">{{ placer.user?.firstName }}</div>
          </div>
          <div class="counter-badge">
            <div
              *ngIf="tour.tourItems?.length > 0"
              class="rounded-ricle counter-badge-display center-text"
              [ngClass]="placerNameBackgroundClass"
            >
              <span>
                {{ counter }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="branch-name-container">
      <div class="vertical-center-container">
        <div class="branch">
          <div class="vertical-center">
            <div style="width: 32px"></div>
          </div>
          <div class="vertical-center">
            <div class="branch-name">{{ placer.branch?.name }}</div>
          </div>
          <div class="counter-badge">
            <div
              *ngIf="placer.numberOfJobs > 0"
              class="rounded-ricle jobs-badge-display center-text"
            >
              <span>
                {{ placer.numberOfJobs }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tour-item-container" [ngClass]="placerNameBackgroundClass">
      <div class="tour-item-list">
        <ng-container *ngIf="tour.tourItems?.length > 0">
          <div
            *ngFor="
              let tourItem of tour.tourItems | reverseIterable;
              trackBy: trackById
            "
            [ngClass]="tourItem.tourItemExecutionClass"
          >
            <ng-container *ngIf="tourItem.subProject != null">
              <div
                *ngIf="tourItem.subProject != null"
                class="tour-item"
                [ngClass]="tourItem.tourItemBackgroundClass"
              >
                <div class="tour-item-inner">
                  <div
                    *ngIf="tourItem.subProject.currentRequestDate != null"
                    class="on-date"
                  ></div>
                  <div
                    *ngIf="tourItem.subProject.withAppointment"
                    class="with-appointment"
                  ></div>
                  <div class="vertical-center-container center-text">
                    <span>{{
                      tourItem.subProject.address?.postalCode
                        | joiner : ' ' : tourItem.subProject.address?.city
                    }}</span>
                  </div>
                  <div
                    [class.double-stones]="
                      tourItem.subProject.onStones &&
                      tourItem.subProject.hasSecondBoard
                    "
                  >
                    <div
                      *ngIf="tourItem.subProject.onStones"
                      class="on-stones"
                    ></div>
                    <div
                      *ngIf="
                        tourItem.subProject.onStones &&
                        tourItem.subProject.hasSecondBoard
                      "
                      class="on-stones"
                    ></div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="tourItem.immoTask != null">
              <div class="tour-item task">
                <div class="tour-item-inner">
                  <div class="vertical-center-container center-text">
                    <span>{{
                      tourItem.immoTask.subject | shortenText : 20
                    }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="action-buttons" [ngClass]="placerNameBackgroundClass">
      <div class="action-button-container">
        <div class="center-button">
          <button
            class="edit-button"
            mat-button
            type="button"
            [disabled]="tour.tourItems == null || tour.tourItems.length < 1"
            (click)="openEmployeeTourEditModal()"
          >
            Edit
          </button>
        </div>
        <div class="center-button preview-toggle-container">
          <button
            class="preview-button preview-1d"
            [ngClass]="previewMode === '1D' ? 'selected-for-preview' : ''"
            mat-button
            type="button"
            [disabled]="
              tour.tourItems == null ||
              tour.tourItems.length < 1 ||
              (!allowPreview && previewMode !== '1D')
            "
            (click)="toggle1DPreview()"
          >
            1D
          </button>
          <button
            class="preview-button preview-2d"
            [ngClass]="previewMode === '2D' ? 'selected-for-preview' : ''"
            mat-button
            type="button"
            [disabled]="
              tour.tourItems == null ||
              tour.tourItems.length < 1 ||
              (!allowPreview && previewMode !== '2D')
            "
            (click)="toggle2DPreview()"
          >
            2D
          </button>
        </div>
      </div>
    </div>
    <div class="checked-checkbox" [ngClass]="placerNameBackgroundClass">
      <div class="route-checked-container">
        <mat-checkbox
          *ngIf="tour.routeChecked"
          class="non-clickable"
          [class.mat-checkbox-disabled]="false"
          [checked]="true"
          [matTooltip]="'Route gemarkeerd als klaar'"
          [ariaLabel]=""
          disabled
        ></mat-checkbox>
      </div>
      <mat-checkbox
        [matTooltip]="
          tour.checked ? 'Volzet ongedaan maken' : 'Markeer als volzet'
        "
        [ariaLabel]=""
        [disabled]="
          (tour.tourItems == null || tour.tourItems.length < 1) && !tour.checked
        "
        [(ngModel)]="tour.checked"
        (ngModelChange)="toggleTourChecked()"
      ></mat-checkbox>
    </div>
    <div
      class="atelier-info"
      [ngClass]="atelierBackgroundClass"
      (click)="openAtelierAssignModal()"
    >
      {{
        tour?.atelierEmployee?.firstName
          | atelierNameDate : (tour?.atelierDate | date : 'dd/MM/yyyy')
      }}
    </div>
  </div>
</ng-template>
